// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G526KGcBaQCg2YBRyoQX {
    width: 34px;
    height: 34px;
    border: 1px solid #e2e5e9;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
    transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;
}
.G526KGcBaQCg2YBRyoQX i {
  font-size: 16px;
  color: var(--main-color-first);
}

/* Survol / focus : légère mise en avant couleur marque */
.G526KGcBaQCg2YBRyoQX:hover,
.G526KGcBaQCg2YBRyoQX:focus,
.G526KGcBaQCg2YBRyoQX:active {
  background: rgba(45, 117, 135, 0.08);
  border-color: var(--main-color-first);
  box-shadow: 0 3px 8px rgba(45, 117, 135, 0.18);
  transform: translateY(-1px);
}

/* Variante bouton d'action principale (ex : "Ajouter") */
.bC83TDbnY6pClS1Yt_Dm {
  background: var(--main-color-first) !important;
  border-color: var(--main-color-first) !important;
  box-shadow: 0 2px 6px rgba(45, 117, 135, 0.3);
}
.bC83TDbnY6pClS1Yt_Dm i {
  color: #fff !important;
}
.bC83TDbnY6pClS1Yt_Dm:hover,
.bC83TDbnY6pClS1Yt_Dm:focus,
.bC83TDbnY6pClS1Yt_Dm:active {
  background: var(--main-color-first) !important;
  filter: brightness(1.08);
  box-shadow: 0 4px 10px rgba(45, 117, 135, 0.4);
  transform: translateY(-1px);
}

.alUCiCIM1MBG8F0ZAEcI {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 190px;
    width: max-content;
    white-space: nowrap;
    background-color: white;
    border: 1px solid #eceff1;
    border-radius: 10px;
    padding: 6px;
    box-shadow: 0 10px 28px rgba(16, 24, 40, 0.14);
    z-index: 9999;
  }

  .uvGFlGMZdRviILvu3vbw {
    display: flex;
    align-items: center;
    height: 34px;
    padding: 0 10px;
    cursor: pointer;
    user-select: none;
    gap: 10px;
    border-radius: 6px;
    transition: background-color 0.12s ease;
  }

  .uvGFlGMZdRviILvu3vbw:hover {
    background: rgba(45, 117, 135, 0.1);
  }

  .kvwMbpNHSWCpVUdqmqgw {
    width: 20px;
    display: flex;
    justify-content: center;
  }

  .ljWF7AG8X7KiMmpNy4QA {
    flex: 1;
    font-size: 14px;
  }

  .RPRPt73rlFlXGFadVk0r {
    height: 1px;
    background: #eef0f2;
    margin: 4px 6px;
  }

  .ugXnXh_r_E3ciYo8E9XA {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }`, "",{"version":3,"sources":["webpack://./src/component/resultat/searchActionsMenu.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,4CAA4C;IAC5C,6GAA6G;AACjH;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA,yDAAyD;AACzD;;;EAGE,oCAAoC;EACpC,qCAAqC;EACrC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,yDAAyD;AACzD;EACE,8CAA8C;EAC9C,gDAAgD;EAChD,6CAA6C;AAC/C;AACA;EACE,sBAAsB;AACxB;AACA;;;EAGE,8CAA8C;EAC9C,wBAAwB;EACxB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,8CAA8C;IAC9C,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,uCAAuC;EACzC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,OAAO;IACP,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;EACtB","sourcesContent":[".butMenu {\n    width: 34px;\n    height: 34px;\n    border: 1px solid #e2e5e9;\n    background: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    border-radius: 8px;\n    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);\n    transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;\n}\n.butMenu i {\n  font-size: 16px;\n  color: var(--main-color-first);\n}\n\n/* Survol / focus : légère mise en avant couleur marque */\n.butMenu:hover,\n.butMenu:focus,\n.butMenu:active {\n  background: rgba(45, 117, 135, 0.08);\n  border-color: var(--main-color-first);\n  box-shadow: 0 3px 8px rgba(45, 117, 135, 0.18);\n  transform: translateY(-1px);\n}\n\n/* Variante bouton d'action principale (ex : \"Ajouter\") */\n.butMenuPrimary {\n  background: var(--main-color-first) !important;\n  border-color: var(--main-color-first) !important;\n  box-shadow: 0 2px 6px rgba(45, 117, 135, 0.3);\n}\n.butMenuPrimary i {\n  color: #fff !important;\n}\n.butMenuPrimary:hover,\n.butMenuPrimary:focus,\n.butMenuPrimary:active {\n  background: var(--main-color-first) !important;\n  filter: brightness(1.08);\n  box-shadow: 0 4px 10px rgba(45, 117, 135, 0.4);\n  transform: translateY(-1px);\n}\n\n.winMenu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    min-width: 190px;\n    width: max-content;\n    white-space: nowrap;\n    background-color: white;\n    border: 1px solid #eceff1;\n    border-radius: 10px;\n    padding: 6px;\n    box-shadow: 0 10px 28px rgba(16, 24, 40, 0.14);\n    z-index: 9999;\n  }\n\n  .winItem {\n    display: flex;\n    align-items: center;\n    height: 34px;\n    padding: 0 10px;\n    cursor: pointer;\n    user-select: none;\n    gap: 10px;\n    border-radius: 6px;\n    transition: background-color 0.12s ease;\n  }\n\n  .winItem:hover {\n    background: rgba(45, 117, 135, 0.1);\n  }\n\n  .winIcon {\n    width: 20px;\n    display: flex;\n    justify-content: center;\n  }\n\n  .winLabel {\n    flex: 1;\n    font-size: 14px;\n  }\n\n  .winSeparator {\n    height: 1px;\n    background: #eef0f2;\n    margin: 4px 6px;\n  }\n\n  .disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n    pointer-events: none;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"butMenu": `G526KGcBaQCg2YBRyoQX`,
	"butMenuPrimary": `bC83TDbnY6pClS1Yt_Dm`,
	"winMenu": `alUCiCIM1MBG8F0ZAEcI`,
	"winItem": `uvGFlGMZdRviILvu3vbw`,
	"winIcon": `kvwMbpNHSWCpVUdqmqgw`,
	"winLabel": `ljWF7AG8X7KiMmpNy4QA`,
	"winSeparator": `RPRPt73rlFlXGFadVk0r`,
	"disabled": `ugXnXh_r_E3ciYo8E9XA`
};
export default ___CSS_LOADER_EXPORT___;
